import {
	getController,
	apiService as Service,
	type HpRequestOptional,
} from '@/services/service'

const url = 'images'

export const imagesService = {
	...getController<Api.Image, Api.ImagePostInput>(url),
	attachBuilding: ({
		id,
		targetId,
		data,
	}: {
		id: number
		targetId: number
		data?: HpRequestOptional
	}) => Service.post({ url: `${url}/${id}/buildings/${targetId}`, ...data }),
	binary: (id: number) =>
		Service.get({
			url: `${url}/${id}/binary`,
			responseType: 'blob',
		}),
	setMainImage: (buildingId: number, imageId: number) =>
		Service.post({
			url: `${url}/${imageId}/buildings/${buildingId}/cover`,
		}),
	detachBuilding(image_id: number, building_id: number) {
		return Service.delete({
			url: `${url}/${image_id}/buildings/${building_id}`,
		})
	},
}

export default imagesService
